














import { Component, Vue } from 'vue-property-decorator';
import BillItemSelect from '@/components/bill/SelectBillItems.vue';
import NavBar from '@/components/layout/NavBar.vue';
import fetchBillQuery from '@/graphql/queries/FetchBill.gql';
import { fetchBill_bills } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    bills: {
      query: fetchBillQuery,
      variables() {
        return {
          billArgs: { billId: this.$route.params.id }
        };
      },
      update(data) {
        return data && data.bills[0];
      },
      fetchPolicy: 'no-cache'
    }
  },
  components: {
    BillItemSelect,
    NavBar
  }
})
export default class BillsEdit extends Vue {
  private bills: fetchBill_bills | null = null;

  private revert(): void {
    if (!this.bills) {
      return;
    }
    this.$router.push({ name: 'billDetails', params: { id: this.bills.id } });
  }

  get collectShipmentIds(): string[] | void {
    const shipmentIds: string[] = [];

    if (this.bills && this.bills.shipments) {
      this.bills.shipments.forEach((shipment: any) => shipmentIds.push(shipment.id));
    }

    return shipmentIds;
  }
}
